"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ChatMessagesList: ()=>ChatMessagesList
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_BlockingInputComponent_js_namespaceObject = require("./BlockingInputComponent.js");
const ButtonChipsAction_js_namespaceObject = require("./components/ButtonChipsAction/ButtonChipsAction.js");
const CalendarComponent_js_namespaceObject = require("./components/CalendarComponent/CalendarComponent.js");
var CalendarComponent_js_default = /*#__PURE__*/ __webpack_require__.n(CalendarComponent_js_namespaceObject);
const DisplayFeedbackMarker_js_namespaceObject = require("./components/DisplayFeedbackMarker/DisplayFeedbackMarker.js");
var DisplayFeedbackMarker_js_default = /*#__PURE__*/ __webpack_require__.n(DisplayFeedbackMarker_js_namespaceObject);
const ChatMessageErrorBoundary_js_namespaceObject = require("./components/ErrorBoundary/ChatMessageErrorBoundary.js");
var ChatMessageErrorBoundary_js_default = /*#__PURE__*/ __webpack_require__.n(ChatMessageErrorBoundary_js_namespaceObject);
const HandleSetiActions_js_namespaceObject = require("./components/HandleSetiActions.js");
var HandleSetiActions_js_default = /*#__PURE__*/ __webpack_require__.n(HandleSetiActions_js_namespaceObject);
const OpenMapButton_js_namespaceObject = require("./components/Maps/OpenMapButton.js");
const ClientMarkdownParsingComponent_js_namespaceObject = require("./components/MarkdownComponent/ClientMarkdownParsingComponent.js");
const ShowCancelConsequencesMarker_js_namespaceObject = require("./components/ShowCancelConsequencesMarker/ShowCancelConsequencesMarker.js");
var ShowCancelConsequencesMarker_js_default = /*#__PURE__*/ __webpack_require__.n(ShowCancelConsequencesMarker_js_namespaceObject);
const SignOutActions_js_namespaceObject = require("./components/SignOutActions/SignOutActions.js");
var SignOutActions_js_default = /*#__PURE__*/ __webpack_require__.n(SignOutActions_js_namespaceObject);
const TripProtectionMarker_js_namespaceObject = require("./components/TripProtectionMarker/TripProtectionMarker.js");
var TripProtectionMarker_js_default = /*#__PURE__*/ __webpack_require__.n(TripProtectionMarker_js_namespaceObject);
const Trips_js_namespaceObject = require("./components/Trips/Trips.js");
var Trips_js_default = /*#__PURE__*/ __webpack_require__.n(Trips_js_namespaceObject);
const HotelDetailCard_js_namespaceObject = require("./HotelComponent/HotelDetailCard.js");
const external_QuickActions_js_namespaceObject = require("./QuickActions.js");
const external_QuickActionsChips_js_namespaceObject = require("./QuickActionsChips.js");
const external_ScrollIntoView_js_namespaceObject = require("./ScrollIntoView.js");
const external_TravelBotChatSingleDialogGeneric_js_namespaceObject = require("./TravelBotChatSingleDialogGeneric.js");
const DisappearingGradientBox = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "ChatMessagesCollections__DisappearingGradientBox"
})([
    "position:relative;&::before{content:'';position:absolute;top:0;left:0;width:16px;height:",
    ";background:linear-gradient(to left,rgba(255,255,255,0),rgba(255,255,255,1));pointer-events:none;z-index:1000;opacity:",
    ";}&::after{content:'';position:absolute;top:0;right:0;width:16px;height:",
    ";background:linear-gradient(to right,rgba(255,255,255,0),rgba(255,255,255,1));pointer-events:none;z-index:1000;opacity:",
    ";}"
], ({ isLastMessage })=>isLastMessage ? '79px' : '0px', ({ showStartGradient })=>showStartGradient ? 1 : 0, ({ isLastMessage })=>isLastMessage ? '79px' : '0px', ({ showEndGradient })=>showEndGradient ? 1 : 0);
const ChatMessagesList = ({ chatMessages, markerComponents, isLoading, debugMode, setIsDisablingInputValue, setChatMessages, submitMessages, submitChatMessageInMarkerComponent, submitQuickActionMessage, isShowMoreListingCards, isStandalone, messagesEndRef, clearActionsData, isMobile })=>{
    const chatmessageCount = chatMessages.length - 1;
    const [showQuickActionStartGradient, setShowQuickActionStartGradient] = external_react_default().useState(false);
    const [showQuickActionEndGradient, setShowQuickActionEndGradient] = external_react_default().useState(true);
    const handleQuickActionScroll = function(e) {
        const element = e.currentTarget;
        const isScrolledToBeginning = 0 === element.scrollLeft;
        const isScrolledToEnd = Math.abs(element.scrollWidth - element.clientWidth - element.scrollLeft) < 1;
        setShowQuickActionStartGradient(!isScrolledToBeginning);
        setShowQuickActionEndGradient(!isScrolledToEnd);
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            chatMessages.map((m, i)=>{
                const isLastMessage = chatMessages.length - 1 === i;
                const hasOtherMessageHandler = (m, chatMessage)=>{
                    const mappedChatMessage = chatMessage.map((result)=>JSON.stringify(result));
                    const index = mappedChatMessage.indexOf(JSON.stringify(m));
                    return chatMessage.length - 1 > index;
                };
                if (markerComponents[m?.displayComponentName]) {
                    const Marker = markerComponents[m.displayComponentName];
                    const markerComponentProps = m?.markerComponentProps || {};
                    const markerProps = {
                        ...markerComponentProps,
                        message: m,
                        isLoading,
                        chatMessages,
                        setIsDisablingInputValue,
                        setChatMessages,
                        submitMessages,
                        clearActionsData
                    };
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                            compnentName: m.displayComponentName,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Marker, {
                                ...markerProps
                            })
                        })
                    }, `chat-msg-host-app-marker-${i}`);
                }
                if (m?.displayComponentName === 'SEPARATOR_COMPONENT') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        mb: 4,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessageSeparator, {})
                    })
                }, `chat-msg-content-separator-${i}`);
                if ('chatContentSeparator' === m.role) {
                    const content = m.content;
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            mb: 4,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessageSeparator, {
                                message: content
                            })
                        })
                    }, `chat-msg-content-separator-${m.key}-${i}`);
                }
                if (m?.role && m?.content) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "TravelBotChatSingleDialogGeneric",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelBotChatSingleDialogGeneric_js_namespaceObject.TravelBotChatSingleDialogGeneric, {
                            message: m
                        })
                    })
                }, `chat-msg-generic-message-${i}`);
                if (m?.displayComponentName === 'INLINE_METADATA_MARKER') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "TextWithInlineMetadataComponent",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ClientMarkdownParsingComponent_js_namespaceObject.ClientMarkdownParsingComponent, {
                            ...m?.markerComponentProps,
                            isMobile: isMobile,
                            date: m.date
                        })
                    })
                }, `chat-msg-metadata-marker${i}`);
                if (m?.displayComponentName === 'FIRE_SETI') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(HandleSetiActions_js_default(), {
                            setiValues: m?.markerComponentProps?.setiValues
                        })
                    })
                }, `chat-msg-seit-action-message-${i}`);
                if (m?.displayComponentName === 'QUICK_ACTIONS') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DisappearingGradientBox, {
                    showStartGradient: showQuickActionStartGradient,
                    showEndGradient: showQuickActionEndGradient,
                    isLastMessage: isLastMessage,
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_QuickActions_js_namespaceObject.QuickActions, {
                                isStandalone: isStandalone,
                                isSingleLine: true,
                                quickActions: m?.markerComponentProps?.quickActions,
                                hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
                                submitQuickActionMessage: submitQuickActionMessage,
                                isSeparatorMsg: m?.markerComponentProps?.isSeparatorMsg && chatmessageCount === i,
                                onScroll: handleQuickActionScroll
                            })
                        })
                    })
                }, `chat-msg-quick-actions-${i}`);
                if (m?.displayComponentName === 'QUICK_ACTIONS_CHIPS') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_QuickActionsChips_js_namespaceObject.QuickActionsChips, {
                            quickActions: m?.markerComponentProps?.quickActions,
                            hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
                            submitQuickActionMessage: submitQuickActionMessage,
                            isSeparatorMsg: m?.markerComponentProps?.isSeparatorMsg && chatmessageCount === i
                        })
                    })
                }, `chat-msg-quick-chips-${i}`);
                if (m?.displayComponentName === 'BUTTON_CHIPS_ACTION') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ButtonChipsAction_js_namespaceObject.ButtonChipsAction, {
                            submitButtonChipActionMessage: submitQuickActionMessage,
                            hasOtherMessage: hasOtherMessageHandler(m, chatMessages),
                            buttonChipsActions: m?.markerComponentProps?.quickActions,
                            isSeparatorMsg: m?.markerComponentProps?.isSeparatorMsg && chatmessageCount === i
                        })
                    })
                }, `chat-msg-button-chips-actions-${i}`);
                if (m?.displayComponentName === 'SESSION_INITIALIZED') return null;
                if (m?.displayComponentName === 'HOTEL_CARDS_MARKER') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "HotelDetailCardsMessage",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(HotelDetailCard_js_namespaceObject.HotelDetailCardsMessage, {
                            ...m?.markerComponentProps,
                            date: m.date,
                            setChatMessages: setChatMessages,
                            isShowMoreListingCards: isShowMoreListingCards,
                            submitMessages: submitChatMessageInMarkerComponent
                        })
                    })
                }, `chat-msg-hotel-cards-marker-${i}`);
                if (m?.displayComponentName === 'DATE_COMPONENT') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "CalendarComponent",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CalendarComponent_js_default(), {
                            markerComponentProps: m?.markerComponentProps,
                            isLastMessage: isLastMessage
                        })
                    })
                }, `chat-msg-block-input-marker-${i}`);
                if (m?.displayComponentName === 'BLOCK_INPUT_MARKER') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BlockingInputComponent_js_namespaceObject.BlockingInputComponent, {
                        setIsDisablingInputValue: setIsDisablingInputValue
                    })
                }, `chat-msg-block-input-marker-${i}`);
                if (m?.displayComponentName === 'PROMPT_TRIP_PROTECTION') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "TripProtectionMarker",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TripProtectionMarker_js_default(), {})
                    })
                }, `chat-msg-trip-protection-marker-${i}`);
                if (m?.displayComponentName === 'DISPLAY_MY_TRIPS') {
                    const { tripsList: trips, hasMoreTrips, deepLinkPrompt, tripHeaderMsg } = m?.markerComponentProps || {};
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                            compnentName: "Trips",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Trips_js_default(), {
                                trips: trips,
                                deepLinkPrompt: deepLinkPrompt,
                                tripHeaderMsg: tripHeaderMsg,
                                hasMoreTrips: hasMoreTrips,
                                submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent
                            })
                        })
                    }, `chat-msg-display-my-trips-marker-${i}`);
                }
                if (m?.displayComponentName === 'SHOW_SIGNED_OUT_ACTION_BUTTONS') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "SignOutActions",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(SignOutActions_js_default(), {
                            submitMessagesFn: submitMessages,
                            ...m?.markerComponentProps || {}
                        })
                    })
                }, `chat-msg-signed-out-actions-marker${i}`);
                if (m?.displayComponentName === 'DISPLAY_FEEDBACK_MARKERS') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "DisplayFeedbackMarkers",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DisplayFeedbackMarker_js_default(), {
                            ...m?.markerComponentProps
                        })
                    })
                }, `chat-msg-display-feedback-marker${i}`);
                if (m?.displayComponentName === 'SHOW_CANCEL_CONSEQUENCES_MARKER') return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                        compnentName: "ShowCancelConsequencesMarker",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ShowCancelConsequencesMarker_js_default(), {
                            cancelConsequences: {
                                ...m?.markerComponentProps || {}
                            }
                        })
                    })
                }, `chat-msg-show_cancel_consequences_marker${i}`);
                if (m?.displayComponentName && debugMode) {
                    console.log('Debug Mode', m?.displayComponentName);
                    console.log(JSON.stringify(m, null, 2));
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                                    children: [
                                        "Marker Component Name: ",
                                        m?.displayComponentName
                                    ]
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                                    children: [
                                        "Check dev console for more details of ",
                                        m?.displayComponentName,
                                        " component props"
                                    ]
                                })
                            ]
                        })
                    }, `chat-msg-marker-${i}`);
                }
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(OpenMapButton_js_namespaceObject.OpenMapButton, {
                isLoading: isLoading,
                isStandalone: isStandalone,
                isMobile: isMobile
            }),
            isStandalone ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                ref: messagesEndRef,
                style: {
                    height: 0
                }
            }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {})
        ]
    });
};
ChatMessagesList.displayName = 'ChatMessagesList';
exports.ChatMessagesList = __webpack_exports__.ChatMessagesList;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ChatMessagesList"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
